export default __webpack_public_path__ + "static/media/CloseRoom.843061b9.svg";